<template src="./index.html"></template>
<script>
	import addzc from '../addzc/index.vue';
	import seezc from '../seezc/index.vue';
	import config from '../../../../configHttp.js';
	import uploadFile from '../uploadFile/index.vue';
	import uploadFileplus from '../uploadFileplus/index.vue';
	import axios from 'vue';
	import data from './data.js';
	import {
		querycell,
		writesave,
		startShenBao,
		forShengcdg,
		manuscriptqueryReportStep,
		manuscriptwriteimport,
		manuscriptUploadFile,
		annexadd,
		UploadNotes,
		queryNotes,
		query_Appended,
		cwbb_appended_save,
		cwbb_appended_update
	} from '../../../api/Draftgeneration.js';
	import {
		querytemplatecell,
		getShuibDetailList,
		templatecellsave
	} from '../../../api/bbmb.js';
	import {
		reportquerytrack
	} from '../../../api/xggj.js';
	import {
		zcfg_fycx,
		zcfg_fetch
	} from '../../../api/zcfg.js';
	export default {
		name: '',
		components: {
			addzc,
			seezc,
			uploadFile,
			uploadFileplus
		},
		data: function() {
			return {
				//文件上传
				filediag: false,
				//文件附注
				fileUpload: false,
				notes: null,
				upformdata: {},
				formdata: {
					type: '',
					name: '',
					description: ''
				},
				upfile: {},
				updiag: false,
				formlist: data.formlist,
				choosetable: [],
				chooseindex: '',
				choosecolum: {},
				smdiag: false,
				//单元格批注
				pzdiag: false,
				zcdiag: false,
				//政策
				addzcdiag: false,
				searchdatazc: {
					policyTitle: '',
					policyType: '',
					isValid: ''
				},
				searchlistzc: data.searchlistzc,
				headDatazc: data.headDatazc,
				tableDatazc: [],
				pagination: data.pagination,
				seezcformlist: data.seezcformlist,
				formdatazc: data.formdatazc, //form表单数据
				fbkyuwduixi: {
					originalLink: '',
					content: ''
				}, //源文件链接文本框数据
				zclist: [], //政策
				upformdataadd: [], //文件
				seezcdiag: false,
				Asmtext: this.smtext,
				Appended: {
					"bianzjc": "",
					"companyNo": "",
					"createBy": null,
					"createTime": null,
					"delFlag": "0",
					"gengzsm": "",
					"id": null,
					"kuaijgj": "",
					"qiyjbqk": "",
					"shenbq": "",
					"shuibId": null,
					"shuomsx": "",
					"updateBy": null,
					"updateTime": null,
					"xiangmsm": "",
					"zhengccxxx": "",
					"zunxsm": ""
				},
			};
		},
		props: {
			type: {
				type: String,
				default: ''
			},
			params: {
				type: Object,
				default: {}
			},
			suosq: {
				type: String,
				default: ''
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			choosetitleindex: {
				type: String,
				default: ''
			},
			choosecellCode: {
				type: String,
				default: ''
			},
			smtext: {
				type: String,
				default: ''
			},
			zcdata: {
				type: Array,
				default: []
			},
      jiaJDkBl: {
        type: String,
        default: ''
      },
      baohckyw: {
        type: String,
        default: ''
      }
		},
		created() {},
		mounted() {
			this.onkeydown();
		},
		activated() {
			this.onkeydown();
		},
		deactivated() {
			document.onkeydown = '';
		},
		methods: {
			Upload_notes() {
				// this.$emit("Upload_notes",'')
				let params = {
					"companyNo": this.params.companyNo,
					"shenbq": this.suosq,
					"shuibId": this.params.shuibId,
				}
				query_Appended(params).then((res) => {
					if (res.data.code == 1) {
						if (res.data.data != null) {
							this.Appended = res.data.data
						}
						this.fileUpload = true;
					} else {
						this.$message.error(res.data.msg);
					}
				})
				// this.$nextTick(() => {
				// 	this.$refs['uploadfileRef'].forrefresh();
				// });
				this.query_Notes();
			},
			getupload_notes_params(e) {
				this.upformdata = e;
			},
			notes_file() {
				let params = {
					downUrl: config.baseURL + '/manuscript/downloadCwbbFile',
					typeObj: {
						toForm: true,
						fileType: 'xlsx',
						failUrl: this.$winURl
					},
					params: {
						id: this.params.id
					}
				};
				this.$downloadcommon(params);
			},
			query_Notes() {
				queryNotes({
					id: this.params.id
				}).then((res) => {
					if (res.data.code == 1) {
						this.notes = res.data.data.fileName;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			//确认上传
			forsubmit_notes_file() {
				this.Appended.companyNo = this.params.companyNo
				this.Appended.shenbq = this.suosq
				this.Appended.shuibId = this.params.shuibId
				if (this.Appended && (this.Appended.id != "" && this.Appended.id != null && this.Appended.id !=
						undefined)) {
					cwbb_appended_update(this.Appended).then(res => {
						if (res.data.code == 1) {
							this.$message.success("操作成功！");
							this.fileUpload = false;
						} else {
							this.$message.error(res.data.msg);
						}
					})
				} else {
					cwbb_appended_save(this.Appended).then(res => {
						if (res.data.code == 1) {
							this.$message.success("操作成功！");
							this.fileUpload = false;
						} else {
							this.$message.error(res.data.msg);
						}
					})
				}
				// UploadNotes({
				// 	file: this.upformdata.upfile,
				// 	id: this.params.id
				// }).then((res) => {
				// 	if (res.data.code == 1) {
				// 		this.fileUpload = false;
				// 	} else {
				// 		this.$message.error(res.data.msg);
				// 	}
				// });
			},
			get_notes_filelist() {},
			forsave() {
				this.$emit('forsave', '');
			},
			commanddcrefresh(e) {
				this.$emit('commanddcrefresh', e);
			},
			zcsclick(id) {
				let params = {};
				params.id = id;
				zcfg_fetch(params).then((res) => {
					if (res.data.data != null) {
						this.formdata = res.data.data;
						this.formdata.id = id;
						this.zclist = res.data.data.policyList;
						this.upformdataadd = res.data.data.policyFileList.map((item) => {
							return {
								upfilename: item.filePrefix + item.fileSuffix,
								suoming: item.fileDesc,
								policyFileList: item.id,
								fileUrl: item.fileUrl
							};
						});
						this.seezcdiag = true;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			closeseezcdiag() {
				this.seezcdiag = false;
			},
			// 查询进行发票合计结果(分页)
			fetchResultShow() {
				let params = JSON.parse(JSON.stringify(this.searchdatazc));
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				params.sort = '';
				params.order = '';
				zcfg_fycx(params).then((res) => {
					this.pagination.total = res.data.data.total;
					this.tableDatazc = res.data.data.records;
					this.addzcdiag = true;
				});
			},
			sizechange(e) {
				this.pagination.pageSize = e;
				this.fetchResultShow();
			},
			currentChange(e) {
				this.pagination.pageNum = e;
				this.fetchResultShow();
			},
			submitSearch() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.fetchResultShow();
			},
			foraddzc() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.fetchResultShow();
			},
			addzc() {
				const chooseval = this.$refs.tablebox.getSelectionval();
				chooseval.forEach((item) => {
					if (!(this.zcdata && this.zcdata.map((gtem) => gtem.id).includes(item.id))) {
						this.zcdata.push(item);
					}
				});
				this.addzcdiag = false;
			},
			onkeydown() {
				document.onkeydown = () => {
					if (window.event && (window.event.keyCode == 112 || window.event.keyCode == 16)) {
						if (this.type == 'tosee' && !this.toseeUpdate) {
							return false;
						}
						if (this.$emptyandnull(this.choosetable)) {
							if (window.event.keyCode == 16) {
								return false;
							}
							if (this.toseeUpdate) {
								this.$message.error('请选择要添加说明的格子');
							} else {
								this.$message.error('请选择要更正说明的格子');
							}
							return false;
						}
						if (this.toseeUpdate) {
							this.pzdiag = true;
						} else {
							this.smdiag = true;
						}
						return false;
					}
					if (window.event && window.event.keyCode == 9) {
						this.refreshhover();
					}
				};
			},
			forxzsm() {
				templatecellsave({
					cellCode: this.choosecellCode,
					cellDesc: this.Asmtext,
					id: this.params.id,
					zcId: this.zcdata.map((item) => item.id)
				}).then((res) => {
					if (res.data.code == 1) {
						this.pzdiag = false;
						this.$emit('forxzsm', this.choosetable, this.choosecolum, this.chooseindex, this.Asmtext,
							this.zcdata);
					}
				});
			},
			forgengzheng() {
				this.smdiag = false;
				this.$emit('forgengzheng', this.choosetable, this.choosecolum, this.chooseindex, this.Asmtext);
			},
			fordelete(index) {
				this.zcdata.splice(index, 1);
			},
			zcsearch() {
				this.zcdiag = true;
			},
			//选中格子
			forhover(table, colum, index) {
				this.refreshhover();
				this.choosetable = table;
				this.chooseindex = index;
				this.choosecolum = colum;
				this.$emit('getchoosecellCode', table, colum, index);
			},
			//重置所有说明
			refreshhover() {
				if (this.smdiag || this.pzdiag) {
					return false;
				}
				this.choosetable = '';
				this.chooseindex = '';
				this.choosecolum = {};
				this.$emit('getchoosecellCode', '');
			},
			//按钮逻辑
			forsb() {
				let params = {
					aggOrgId: '406309843523776',
					companyNo: '123456789A001',
					period: '7',
					id: '1548949165625737218',
					szType: 'ybData',
					year: '2022'
				};
				startShenBao(params).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			// 一键生成底稿
			forShengcdg() {
				let params = {
					companys: [{
						companyNo: this.params.companyNo,
						id: this.params.id,
						sbbm: this.params.sbbm,
						shuibId: this.params.shuibId,
						templateId: this.params.templateId
					}],
					suosq: this.suosq
				};
				forShengcdg(params).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.$emit('querycell', 'forShengcdg');
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			forseegj() {
				this.$router.push({
					path: '/gjck',
					query: {
						Saleparam: JSON.stringify(this.params),
						suosq: this.suosq
					}
				});
			},
			commanddc(e) {
				console.log(e);

				if (e == 'excel') {
					let params = {
						downUrl: config.baseURL + 'manuscript/write/export',
						typeObj: {
							toForm: false,
							//fileName:"申报报表",
							fileType: 'xlsx',
							failUrl: this.$winURl
						},
						params: {
							companyNo: this.params.companyNo,
							id: this.params.id,
							sbbm: this.params.sbbm,
							shuibId: this.params.shuibId
						}
					};
					this.$downloadcommon(params);
				} else if (e == 'pdf') {
					let params = {
						downUrl: config.baseURL + 'manuscript/write/exportPdf',
						typeObj: {
							toForm: false,
							//fileName: "申报报表",
							fileType: 'pdf',
							failUrl: this.$winURl
						},
						params: {
							companyNo: this.params.companyNo,
							id: this.params.id,
							sbbm: this.params.sbbm,
							shuibId: this.params.shuibId
						}
					};
					console.log(params);
					this.$downloadcommon(params);
				}
			},
			//上传附件
			getuploadparamsplus(e) {
				
				this.upfile.file=e.upfile
				this.upfile.fileName = e.upfilename;
				
				// manuscriptUploadFile({
				// 	file: e.upfile
				// }).then((res) => {
				// 	if (res.data.code == 1) {
				// 		this.upfile.fileName = res.data.data.fileName;
				// 		this.upfile.fileUrl = res.data.data.fileUrl;
				// 	} else {
				// 		this.$message.error(res.data.msg);
				// 	}
				// });
			},
			closeupdiag() {
				this.updiag = false;
			},
			forsubmit() {
				if (this.$emptyandnull(this.upfile.fileName)) {
					this.$message.error('请选择要上传的文件');
					return false;
				}
				let params = JSON.parse(JSON.stringify(this.formdata));
				// params.fileName = this.upfile.fileName;
				// params.fileUrl = this.upfile.fileUrl;
				params.file = this.upfile.file;
				params.id = this.upfile.id;
				annexadd(params).then(res => {
					if (res.data.code == 1) {
						this.updiag = false;
						this.$message.success(res.data.msg);
					} else {
						this.$message.error(res.data.msg);
					}
				});
				
				
				// if (this.$emptyandnull(this.upfile.fileUrl)) {
				// 	this.$message.error('请选择要上传的文件');
				// 	return false;
				// }
				// let params = JSON.parse(JSON.stringify(this.formdata));
				// params.fileName = this.upfile.fileName;
				// params.fileUrl = this.upfile.fileUrl;
				// params.id = this.upfile.id;
				// annexadd(params).then((res) => {
				// 	if (res.data.code == 1) {
				// 		this.updiag = false;
				// 		this.$message.success(res.data.msg);
				// 	} else {
				// 		this.$message.error(res.data.msg);
				// 	}
				// });
			},
			forupdiag() {
				Object.keys(this.formdata).map((key) => (this.formdata[key] = ''));
				Object.keys(this.upfile).map((key) => (this.upfile[key] = ''));
				this.upfile.id = this.params.id;
				this.updiag = true;
			},
			//文件导入
			forupload() {
				this.upformdata = {};
				this.filediag = true;
				this.$nextTick(() => {
					this.$refs['uploadfileRef'].forrefresh();
				});
			},

			//下载模板
			fordownloadmb() {
				let params = {
					downUrl: config.baseURL + 'manuscript/write/uploads',
					typeObj: {
						toForm: true,
						fileName: '报表模板',
						fileType: 'xlsx',
						failUrl: this.$winURl
					},
					params: {
						sbbm: this.params.sbbm
					}
				};
				this.$downloadcommon(params);
			},
			//获取下载参数
			getuploadparams(e) {
				this.upformdata = e;
			},
			//确认上传
			forsubmitfile() {
				manuscriptwriteimport({
					file: this.upformdata.upfile,
					shenbaoid: this.params.id
				}).then((res) => {
					if (res.data.code == 1) {
						this.filediag = false;
						this.$emit('querycell', '');
						this.$message.success(res.data.msg);
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
      exportBusinessSituation() {
        this.$emit('exportBusinessSituation');
      }
    }
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
</style>